module.exports = __webpack_public_path__ + "img/icon-check.96fe00ae.svg";